import React from "react"
import { View } from "react-native"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { baseColors } from "@Constants/baseStyles"
import { Spacer } from "@Components/Space"

export const PasswordValidatorContent = (props) => {
    const passwordWarnings = [
        { label: "8 caractères" },
        { label: "une lettre majuscule" },
        { label: "une lettre minuscule" },
        { label: "un chiffre" },
        { label: "un caractère spécial" }
    ]

    return (
        <View style={{ padding: 10 }}>
            <OpenSansText color={baseColors.grey.dark} style={{ fontWeight: "normal", fontSize: 15 }}>
                Le mot de passe devrait contenir au moins :
            </OpenSansText>
            <Spacer height={10} />
            {passwordWarnings.map((item) => (
                <OpenSansText
                    key={item.label}
                    color={baseColors.orange.dark}
                    fontStyle={"italic"}
                    style={{ fontWeight: "normal", fontSize: 14 }}
                >
                    - {item.label}
                </OpenSansText>
            ))}
        </View>
    )
}
